'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import PropTypes from 'prop-types'

const getOptionId = (option) => {
  if (!option) return null
  return option.expenseClaimTypeId ?? option.claimTypeId ?? option.id ?? option.value ?? null
}

export const ClaimTypeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchClaimTypes, claimTypes } = useLookupsStore()
  const [options, setOptions] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)

  useEffect(() => {
    const rawItems = testData || claimTypes || []
    const normalizedOptions = rawItems.map((item, index) => ({
      ...item,
      value: getOptionId(item) ?? `option-${index}`,
      label: item?.description || item?.label || ''
    }))
    setOptions(normalizedOptions)
  }, [testData, claimTypes])

  useEffect(() => {
    if (!value) {
      setSelectedValue(null)
      return
    }
    const valueId = getOptionId(value)
    const matchingOption = options.find(opt => getOptionId(opt) === valueId)
    setSelectedValue(matchingOption || {
      ...value,
      value: valueId,
      label: value?.description || value?.label || ''
    })
  }, [value, options])

  useEffect(() => {
    if (testData || claimTypes?.length) return
    fetchClaimTypes()
  }, [testData, claimTypes, fetchClaimTypes])

  return (
    <div data-testid="ClaimTypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}>
      <ReactSelectMenu
        label="Claim type"
        onChange={(newVal) => {
          setSelectedValue(newVal)
          onChange(newVal)
        }}
        labelKey="label"
        valueKey="value"
        items={options}
        value={selectedValue}
        searchable
        showIdInResults={false}
        name="claimTypeId"
        size={size}
        required={required}
        errors={errors}
        menuZindex={9999999}
        multi={false}
      />
    </div>
  )
}

ClaimTypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
